import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'
import { HookUtils } from '@front/volcanion/utils'
import { Loader } from '@front/squirtle'

const withContainer = Component => props => {
  const [defaultCountry, , country_state] = hooks.useSetting('country_code')
  const verifyGsm = useCallback(hooks.useRecordExist('user', 'auth.gsm', { driverinfo: { '!': null } }), [])
  const verifyEmail = useCallback(hooks.useRecordExist('user', 'auth.email', { driverinfo: { '!': null } }), [])

  const getDefaultDateTime = useCallback(() => null, [])

  const mergedProps = {
    defaultCountry,
    verifyGsm,
    verifyEmail,
    getDefaultDateTime
  }

  return (
    <Loader isLoading={HookUtils.getLoadingState([country_state])} size={30}>
      <Component {...mergedProps} />
    </Loader>
  )
}
export default withContainer
